import { useState } from 'react';
import logo from '../../assets/logo.png';

import { ReactComponent as Pin } from '../../assets/icons/pin.svg';
import { ReactComponent as ClipBoard } from '../../assets/icons/clipboard.svg';
import { ReactComponent as Overview } from '../../assets/icons/overview.svg';
import { ReactComponent as Reports } from '../../assets/icons/reports.svg';
import { ReactComponent as Lightning } from '../../assets/icons/lightning.svg';
import { StyledNavigation, NavigationLogo, NavigationList, NavigationListItem, Sidebar, SDHeader, SidebarOverlay, SDBody, NavigationListLink, NavigationListLinkHeader, NavigationListSubLink, MobileHeader, DesktopNav, MobileNav } from "./styles";
import { MAP, LISTINGS, CHARGES, REPORTS, CHARGERS } from '../../constants/routeConstants';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import HamburgerIcon from './HamburgerIcon';

const allRoutes = [
  { route: CHARGERS, text: 'Chargers', icon: <Lightning /> },
  { route: LISTINGS, text: 'Listings', icon: <ClipBoard /> },
  { route: CHARGES, text: 'Reservations', icon: <Lightning /> },
  { route: MAP, text: 'Map', icon: <Pin /> },
];

const isActive = (route) => {
  const paths = window.location.pathname.split('/');
  return paths[paths.length - 1] === route.split('/')[1];
};

const LinkListItem = ({ route, text, icon, onClick }) => {
  return (
    <NavigationListItem>
      <NavigationListLink
        isActive={isActive(route)}
        href={route}
        onClick={onClick}
      >
        {icon}
        {text}
      </NavigationListLink>
    </NavigationListItem>
  );
};

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  const renderNavContent = () => (
    <>
      <NavigationLogo src={logo} alt="EVmatch Logo" />
      <NavigationList>
        <LinkListItem 
          route="/" 
          text="Overview" 
          icon={<Overview />} 
          onClick={handleLinkClick}
        />
        <NavigationListItem>
          <NavigationListLinkHeader onClick={() => setExpanded(!expanded)}>
            <Reports />
            Reports {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </NavigationListLinkHeader>
          <div style={{ 
            maxHeight: expanded ? '100%' : 0, 
            overflow: 'hidden', 
            marginTop: expanded ? 10 : 0,
            transition: 'all 0.3s ease-in-out'
          }}>
            <NavigationListSubLink 
              isActive={isActive('/reports')} 
              href="/reports"
              onClick={handleLinkClick}
            >
              Stations
            </NavigationListSubLink>
            <NavigationListSubLink 
              isActive={isActive('/sessions')} 
              href="/reports/sessions"
              onClick={handleLinkClick}
            >
              Sessions
            </NavigationListSubLink>
          </div>
        </NavigationListItem>
        {allRoutes.map(({ route, text, icon }) => (
          <LinkListItem 
            key={text} 
            route={route} 
            text={text} 
            icon={icon}
            onClick={handleLinkClick}
          />
        ))}
      </NavigationList>
    </>
  );

  return (
    <>
      <DesktopNav>
        <StyledNavigation>
          {renderNavContent()}
        </StyledNavigation>
      </DesktopNav>

      <MobileNav>
        <MobileHeader>
          <NavigationLogo src={logo} alt="EVmatch Logo" style={{ margin: 0 }} />
          <HamburgerIcon isOpen={isOpen} onClick={toggleMenu} />
        </MobileHeader>
        <Sidebar isOpen={isOpen}>
          <SDHeader>
            <NavigationLogo src={logo} alt="EVmatch Logo" />
          </SDHeader>
          <SDBody>
            {renderNavContent()}
          </SDBody>
        </Sidebar>
        <SidebarOverlay isOpen={isOpen} onClick={toggleMenu} />
      </MobileNav>
    </>
  );
};

export default Navigation;
